import { render, staticRenderFns } from "./brieHeader.vue?vue&type=template&id=3887a543&scoped=true"
import script from "./brieHeader.vue?vue&type=script&lang=js"
export * from "./brieHeader.vue?vue&type=script&lang=js"
import style0 from "./brieHeader.vue?vue&type=style&index=0&id=3887a543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887a543",
  null
  
)

export default component.exports